export const createPhysicalCardLifecycleIdempotencyKey = (): string => {
  if (
    typeof globalThis.crypto !== 'undefined' &&
    typeof globalThis.crypto.randomUUID === 'function'
  ) {
    return globalThis.crypto.randomUUID()
  }

  return `physical-card-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2)}`
}
